import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('sexMap', function (status) {
  const statusMap = {
    1: '男',
    2: '女',
    3: '未知'
  }
  return statusMap[status]
})

Vue.filter('dayjs', function (dataStr, pattern = 'HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('formatSeconds', function (dataStr) {
  var hh = parseInt(dataStr / 3600)
  if (hh < 10) hh = '0' + hh
  var mm = parseInt((dataStr - hh * 3600) / 60)
  if (mm < 10) mm = '0' + mm
  var ss = parseInt((dataStr - hh * 3600) % 60)
  if (ss < 10) ss = '0' + ss
  var length = hh + ':' + mm + ':' + ss
  if (dataStr > 0) {
    return length
  } else {
    return 'NaN'
  }
})
